/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */

export enum CoursesType {
  PAID = 'paid',
  FREE = 'free',
}

export enum PayloadKey {
  CATEGORIES = 'categories',
  SUBCATEGORIES = 'subcategories',
  DOMAINS = 'domains',
  HASHTAG = 'hashTag',
  ISFREE = 'isFree',
  PROGRAMTYPE = 'programType',
  INSTRUCTORS = 'instructors',
  LEVEL = 'level',
  LANGUAGES = 'languages',
  FILTER_CONFIG_SLUG = 'filterConfigSlug',
  FILTER_CONFIG_SRC = 'filterConfigSrc',
  UNDEFINED = 'undefined',
  PROGRAM = 'program',
  INSTRUCTOR = 'instructor',
  PRICING = 'pricing',
  PAID = 'paid',
  FREE = 'free',
}

export enum OptionLabel {
  PROFESSION = 'profession',
  PROGRAM_TYPE = 'program_type',
  INSTRUCTORS = 'instructors',
  PRICING = 'pricing',
  LANGUAGE = 'language',
  TAGS = 'tags',
  DOMAIN = 'domain',
  SUB_CATEGORY = 'sub_category',
  CATEGORY = 'category',
  ONLINE_DEGREE = 'online_degree_type',
}

export enum productType {
  course = 'Course',
  masterclass = 'Masterclass',
}

export enum courseType {
  placement = 'PLACEMENT',
  regular = 'REGULAR',
  masterclass = 'MASTERCLASS',
}

export enum InputType {
  radio = 'radio',
  checkbox = 'checkbox',
}

export enum QueryLabel {
  Program = 'program',
  FilterByProfession = 'profession',
  Domain = 'domain',
  Category = 'category',
  Instructor = 'instructor',
  SubCategory = 'subCategory',
  Language = 'language',
  Pricing = 'pricing',
  Level = 'level',
  Tags = 'tags',
}

export enum Level {
  SchoolStudent = 'School Student',
  CollegeStudent = 'College Student',
  WorkingProfessional = 'Working Professional',
}

export enum ProgramType {
  Live = 'Live',
  SelfPacedCourses = 'Self-Paced Courses',
  CampusEdge = 'Campus Edge',
  DegreePrograms = 'Degree Program',
  Bootcamps = 'Bootcamps',
  Trending = 'Trending',
  Community = 'Community',
}

export enum LanguageEnum {
  English = 'English',
  Hinglish = 'Hinglish',
  Hindi = 'Hindi',
}

export enum PayloadLabelValues {
  programType = 'programType',
  level = 'level',
  domains = 'domains',
  categories = 'categories',
  instructors = 'instructors',
  languages = 'languages',
  subcategories = 'subcategories',
  isFree = 'isFree',
  text = 'text',
  hashTag = 'hashTag',
  filterConfigSlug = 'filterConfigSlug',
}
